import { render } from "./App.vue?vue&type=template&id=630c0bb6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=630c0bb6&lang=css"

import exportComponent from "/home/runner/work/Make_your_burger/Make_your_burger/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__